/**
 * iter72l · Marketing intro videos surfaced from the Clubs and Vendors
 * marketing pages via the "Watch Video" CTA. To swap: drop the direct
 * MP4/WebM URL (or YouTube/Vimeo link) in below and redeploy.
 *
 * Environment overrides:
 *   REACT_APP_VIDEO_CLUBS   — overrides `clubs.src` at build time
 *   REACT_APP_VIDEO_VENDORS — overrides `vendors.src` at build time
 */
export const marketingVideos = {
  clubs: {
    // Replaced 2026-08-28 — user uploaded a refreshed member-facing intro.
    src:
      process.env.REACT_APP_VIDEO_CLUBS ||
      "https://customer-assets-eiarnc6j.emergentagent.net/job_fairway-orders/artifacts/u1ub0z8e_08230132-87x_final_video%20%281%29.mp4",
    poster:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_fairway-orders/artifacts/u03id746_Untitled%20design%20%2827%29.png",
    title: "See My Crest Club for Private Clubs",
    id: "08230132",
  },
  vendors: {
    // Replaced 2026-08-23 — user swapped in a fresh vendor-facing intro.
    src:
      process.env.REACT_APP_VIDEO_VENDORS ||
      "https://customer-assets-eiarnc6j.emergentagent.net/job_fairway-orders/artifacts/10tbp08p_08222358-iw7_final_video.mp4",
    poster:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_fairway-orders/artifacts/u03id746_Untitled%20design%20%2827%29.png",
    title: "See My Crest Club for Vendors",
    id: "08222358",
  },
};
